<template>
  <div>
    <overlay-offline v-if="exibirOverlayOffline()"></overlay-offline>
    <template v-else>
      <v-dialog fullscreen v-if="isMobile()" :value="true" scrollable>
        <v-card flat class="cor-fundo">
          <v-toolbar color="primary" dark max-height="56" class="rounded-0">
            <v-btn
              icon
              @click="
                rota == '' ? $router.go(-1) : $router.replace({ path: rota })
              "
              v-if="!desabilitarRota"
              ><v-icon>mdi-arrow-left</v-icon></v-btn
            >
            <v-toolbar-title>{{ title }}</v-toolbar-title>
          </v-toolbar>
          <v-card-text class="mt-5">
            <slot></slot>
          </v-card-text>
        </v-card>
      </v-dialog>
      <template v-else>
        <v-card flat class="rounded-lg" color="transparent">
          <v-toolbar flat dense color="transparent">
            <v-toolbar-title
              class="headline font-weight-bold"
              v-html="title"
            ></v-toolbar-title>
            <v-spacer></v-spacer>
            <btn-voltar-tela />
          </v-toolbar>
          <v-card-text>
            <slot></slot>
          </v-card-text>
        </v-card>
      </template>
    </template>
  </div>
</template>

<script>
import BtnVoltarTela from "./BtnVoltarTela.vue";
import OverlayOffline from "./OverlayOffline.vue";

export default {
  components: { BtnVoltarTela, OverlayOffline },
  name: "TelaComponent",
  props: {
    title: String,
    rota: {type: String, default: ""},
    desabilitarRota: {type: Boolean, default: false}
  },
  methods: {
    isMobile() {
      return this.$mq == "sm";
    },
    exibirOverlayOffline() {
      return !navigator.onLine && this.$route.meta.online;
    },
  },
};
</script>

<style>
</style>